import React, { Component, PropTypes } from 'react';
import { hexToRgba, Colors } from 'Css';
import SelectedMarker from './Editor/SelectedMarker';

const css = oxygenCss({
  root: {
    position: 'relative'
  }
});

class StoreEditor extends Component {
  static propTypes = {
    children: PropTypes.node,
    selected: PropTypes.bool,
    onTouchTap: PropTypes.func,
    mark: PropTypes.bool
  };

  static defaultProps = {
    mark: true
  };

  handleTouchTap = () => {
    const { onTouchTap } = this.props;
    onTouchTap && onTouchTap();
  };

  render() {
    const { children, selected, mark, ...other } = this.props;
    return (
      <div className={css.root} {...other}>
        {children}
        {mark && (
          <SelectedMarker
            selected={selected}
            onTouchTap={this.handleTouchTap}
          />
        )}
      </div>
    );
  }
}

export default StoreEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreEditor.js